
const planRouter = [
    {
        path:'create/:patient_sn',
        name:'plan-create',
        component: () => import(/* webpackChunkName: "about" */ '../views/plan/create/create.vue'),
        children:[
            {
                path:'newPlan',
                name:'plan-newPlan',
                component: () => import(/* webpackChunkName: "about" */ '../views/plan/create/newPlanFormView.vue')
            },{
                path:'refine',
                name:'plan-refine',
                component: () => import(/* webpackChunkName: "about" */ '../views/plan/create/refineFormView.vue')
            },{
                path:'retainer',
                name:'plan-retainer',
                component: () => import(/* webpackChunkName: "about" */ '../views/plan/create/retainerFormView.vue')
            },{
                path:'alignerPlan',
                name:'plan-alignerPlan',
                component: () => import(/* webpackChunkName: "about" */ '../views/plan/create/alignerPlanFormView.vue')
            },{
                path:'alignerRetainer',
                name:'plan-alignerRetainer',
                component: () => import(/* webpackChunkName: "about" */ '../views/plan/create/alignerRetainerFormView.vue')
            }
            
        ]
    },{
        path:'uploadPhoto/:plan_sn',
        name:'plan-uploadPhoto',
        component: () => import(/* webpackChunkName: "about" */ '../views/plan/create/uploadPhoto.vue')
    },{ 
        path:'uploadComplaint/:plan_sn',
        name:'plan-uploadComplaint',
        component: () => import(/* webpackChunkName: "about" */ '../views/plan/create/uploadComplaint.vue')
    },{ 
        path:'uploadDoctorOrder/:plan_sn',
        name:'plan-uploadDoctorOrder',
        component: () => import(/* webpackChunkName: "about" */ '../views/plan/create/uploadDoctorOrder.vue')
    },{ 
        path:'detail/:plan_sn',
        name:'plan-detail',
        component: () => import(/* webpackChunkName: "about" */ '../views/plan/detail/detail.vue'),
        children:[
            {
                path:'step',
                name:'plan-step',
                component: () => import(/* webpackChunkName: "about" */ '../views/plan/detail/tabs/step.vue'),
            },{
                path:'scan',
                name:'plan-scan',
                component: () => import(/* webpackChunkName: "about" */ '../views/plan/detail/tabs/scan.vue')
            },{
                path:'photo',
                name:'plan-photo',
                component: () => import(/* webpackChunkName: "about" */ '../views/plan/detail/tabs/photo.vue')
            },{
                path:'doctorOrder',
                name:'plan-doctorOrder',
                component: () => import(/* webpackChunkName: "about" */ '../views/plan/detail/tabs/doctorOrder.vue')
            },{
                path:'complaint',
                name:'plan-complaint',
                component: () => import(/* webpackChunkName: "about" */ '../views/plan/detail/tabs/complaint.vue')
            },{
                path:'design',
                name:'plan-design',
                component: () => import(/* webpackChunkName: "about" */ '../views/plan/detail/tabs/design.vue')
            }
            
        ]
    },{ 
        path:'IPR/:tmp_sn',
        name:'plan-IPR',
        component: () => import(/* webpackChunkName: "about" */ '../views/plan/detail/IPR.vue'),
    }
    
    
]
export default planRouter